import { LoaderCircle } from 'lucide-react';
import { cn } from './utils';

type SpinnerProps = {
  size?: string | number;
  className?: string;
};

export function Spinner({ size, className }: SpinnerProps) {
  return <LoaderCircle size={size} className={cn('text-primary animate-spin', className)} />;
}
